import React, { Component } from "react";
import HistoricSocialSecurity from "../../../components/HistoricSocialSecurity/HistoricSocialSecurity";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimeForm
Description : Componente que invoca al componente Overtime, para la consulta y creación de horas extra.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Overtime
================================================================================ */
class HistoricSocialSecurityForm extends Component{
    render(){
        return(
            <HistoricSocialSecurity/>  
        )   
    }
}

export default HistoricSocialSecurityForm;